var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$route.meta.layout != 'auth')?_c('div',[[(_vm.isUser)?[_c('b-alert',{attrs:{"show":!_vm.isVerified,"variant":"warning"}},[_vm._v(" Для того аби отримати повний доступ до усіх послуг, потрібно "),_c('router-link',{attrs:{"to":{ name: 'my-profile', params: { tab: 'verification' } }}},[_vm._v(" верифікувати аккаунт")])],1)]:_vm._e()]],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }